<template>
    <div class="text-right">
        <div class="text-lg" :class="{'text-sale' : savingsText != null}">
            <div class="text-lg font-semibold leading-[22px]">
                {{ displayPrice }}*
            </div>

            <div v-if="calculatedPrice?.listPrice != null" class="text-sm leading-[18px]">
                {{ t('product.listingCardVariantPrice.saved') }} {{ formatPrice(discountPrice) }}* = {{ discountPercentage }}%
            </div>

            <div
                v-if="savingsText != null"
                class="text-sm leading-[18px]"
                v-html="savingsText"
            />
        </div>

        <div class="text-sm leading-4">
            <ProductPriceUnit :product="variant" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useCurrency } from '#imports'
import { computed } from 'vue'

const { t } = useI18n()
const { formatPrice } = useCurrency()

const props = defineProps<{
    variant: object
}>()

// customFields are already normalized by hblMapProductVariant, no need to normalize again
const specialPrice = computed(() => props.variant?.customFields?.special_price)
const savingsText = computed(() => props.variant?.customFields?.savings_text)
const calculatedPrice = computed(() => props?.variant?.calculatedPrices != null && props?.variant?.calculatedPrices?.length > 0 ? props?.variant?.calculatedPrices[0] : props?.variant?.calculatedPrice)
const discountPrice = computed(() => Math.abs(Number(calculatedPrice.value?.listPrice?.discount)))
const discountPercentage = computed(() => Math.round(Number(calculatedPrice.value?.listPrice?.percentage)))
const displayPrice = computed(() => specialPrice.value ?? formatPrice(calculatedPrice.value?.unitPrice))
</script>
